import React from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { EnemySection } from './components/EnemySection';
import { MechanismSection } from './components/MechanismSection';
import { WhoWeAre } from './components/WhoWeAre';
import { Services } from './components/Services';
import { Benefits } from './components/Benefits';
import { RiskReversal } from './components/RiskReversal';
import { FAQ } from './components/FAQ';
import { Urgency } from './components/Urgency';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-arena text-negro font-nunito selection:bg-ambar/30 selection:text-negro" data-id="element-0">
      <Nav data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <EnemySection data-id="element-4" />
        <MechanismSection data-id="element-5" />
        <WhoWeAre data-id="element-6" />
        <Services data-id="element-7" />
        <Benefits data-id="element-8" />
        <RiskReversal data-id="element-9" />
        <Urgency data-id="element-10" />
        <FinalCTA data-id="element-11" />
        <FAQ data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}